import React from "react";
import { slideShowStyle } from "./slideShowStyle";

const SlideShow = ({ children, index, onClick, styles = {} }) => {
  const { blockStyle = {} } = styles;
  const onClickThumb = () => {
    onClick(index);
  }
  return (
    <div css={[slideShowStyle.thumbBlock, blockStyle]} onClick={onClickThumb} role="button">
      <div>
        {children}
      </div>
    </div>
  );
}

export default SlideShow
